import script from "./GoogleSignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleSignUp.vue?vue&type=script&setup=true&lang=js"

import "./GoogleSignUp.vue?vue&type=style&index=0&id=51512952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51512952"]])

export default __exports__